import { createClient } from "@aluume/shared/lib/supabase/client";

// Sign-OUT for the AGENT portal (staff use phone-OTP in the staff app, not this).
//
// SIGN-IN AND PASSWORD-RESET USED TO LIVE HERE and no longer do — they are in
// lib/auth/account.ts, called from /login and /account/reset, the single form of
// each for the whole customer app. Accounts are still provisioned by staff (POST
// /api/staff/agents creates the auth user + links agents.auth_user_id); there is no agent
// self-signup, and the custom_jwt_claims hook (0069/0288) stamps app_role='agent' + agent_id
// once the agents row is linked.
//
// What was removed was a byte-for-byte copy of lib/auth/member.ts's sign-in, plus a SECOND
// definition of where a password-reset link lands. That second definition is what made the
// bug possible: a founder's reset mail landed on the agent screen, which refused them.

export async function signOutAgent() {
  await createClient().auth.signOut();
}
